import {
    CoreFetch,
    EligibilityApi,
    ListProviderClaimEligibilitiesRequest,
    ProviderClaimEligibility,
} from '@enter/core';
import { IEligibilityListing } from './eligibility.store';
import { fetch, parseResponse } from './util';

export class EligibilityService {
    public async fetchEligibilityListing(
        lpcr: ListProviderClaimEligibilitiesRequest,
    ): Promise<IEligibilityListing | undefined> {
        const res = await fetch(lpcr, req =>
            CoreFetch<EligibilityApi>(EligibilityApi).listProviderClaimEligibilitiesRaw(req),
        );
        if (res) {
            return {
                eligibilities: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }
    public async fetchEligibility(id: string): Promise<ProviderClaimEligibility | undefined> {
        return fetch({ id }, req => CoreFetch<EligibilityApi>(EligibilityApi).getProviderClaimEligibility(req));
    }
}
